export function LightBulbIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none">
            <path
                stroke="#D0AAF1"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.667}
                d="M9.01 16.04h-2M9.676 14.76H6.343M8.01 1.32v1.92M2.352 3.57l1.415 1.357M13.666 3.57l-1.414 1.357M.343 9h2M15.676 9h-2"
            />
            <path
                stroke="#D0AAF1"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.667}
                d="M12.01 9c.001-1.823-1.332-3.396-3.192-3.765-1.86-.368-3.734.57-4.484 2.245-.75 1.675-.17 3.625 1.39 4.667.178.12.285.316.285.525v.488c0 .177.15.32.334.32h3.333a.327.327 0 0 0 .333-.32v-.488c0-.21.107-.406.286-.526 1.074-.715 1.715-1.89 1.714-3.146v0Z"
                clipRule="evenodd"
            />
        </svg>
    );
}
